import { Box, Button } from 'grommet';
import { useAppSelector } from '../../../../redux';
import React from 'react';
import { useDispatch } from 'react-redux';
import { removeTreesFromField, resetField } from '../../../../redux/actions/map-actions/field/field-action';
import { useParams } from 'react-router-dom';

import { Feature } from '@turf/helpers';
import { ClassificationLayersStatus } from '../../../../service/common/constants';

export const FieldClassificationActons = ({ field }: { field: Feature }): JSX.Element => {
  const { journeyId } = useParams();
  const dispatch = useDispatch();
  const removingTrees = useAppSelector((state) => state.map.removeFromFieldLoading);
  // const removingTrees = useAppSelector((state) => state.dr);
  const canRemove = useAppSelector((state) => state.map.classificationState === ClassificationLayersStatus.SUCCESS);
  const canReset = useAppSelector((state) => state.map.removedFromfields.includes(field.id?.toString() ?? ''));

  return (
    <Box
      direction={'row'}
      gap={'medium'}
      style={{
        // position: 'absolute',
        bottom: '24px',
        left: '24px',
        padding: '7px 7px',
        height: '3rem',
        minWidth: '20rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 130,
        background: '#fff',
        borderRadius: '5px',
      }}>
      <Button
        key={'Remove trees'}
        style={{
          display: 'flex',
          height: '100%',
          padding: '0px 4px',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '8px',
          background: '#FFE137',
          fontWeight: 900,
          lineHeight: '14px',
          letterSpacing: '0.84px',
          fontSize: '12px',
          width: '170px',
        }}
        disabled={!canRemove || removingTrees || field.properties?.editing}
        onClick={() => {
          dispatch(removeTreesFromField(journeyId, field));
        }}>
        {'Remove trees'}
      </Button>
      <Button
        key={'Reset'}
        style={{
          display: 'flex',
          height: '100%',
          padding: '0px 4px',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '8px',
          background: '#FFE137',
          fontWeight: 900,
          lineHeight: '14px',
          letterSpacing: '0.84px',
          fontSize: '12px',
          width: '170px',
        }}
        disabled={!canReset || field.properties?.editing}
        onClick={() => {
          dispatch(resetField(field.id ?? ''));
        }}>
        {'reset'}
      </Button>
    </Box>
  );
};
